import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { AgeingAnalysisReportListType } from "../../../redux/reports/reportsType";
import { currencySignAndNegativeValueAdjust } from "../../../utils/commonFunctions";

type AppProps = {
  tableHeaders: TableHeadersType[];
  tableData: AgeingAnalysisReportListType[] | [];
  clientCode: number;
  companyName: string;
  currencySign: string | undefined;

};
const AgeingAnalysisTableData = ({
  tableHeaders,
  tableData,
  clientCode,
  companyName,
  currencySign
}: AppProps) => {
  return (
    <>
      {tableData &&
        tableData?.length > 0 &&
        tableData?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeaders?.map((item: TableHeadersType) => {
                if (item?.value === "ledger_number") {
                  return <td>{itemData?.ledger_number}</td>;
                }
               else if (item?.value === "legal_name") {
                  return <td>{itemData?.legal_name}</td>;
                } else if (item?.value == "0_to_30_days") {
                  return <td>{currencySignAndNegativeValueAdjust(currencySign ,itemData["0_to_30_days"]?.toFixed(2))}</td>;
                } else if (item?.value == "30_to_60_days") {
                  return <td>{currencySignAndNegativeValueAdjust(currencySign ,itemData["30_to_60_days"]?.toFixed(2))}</td>;
                } else if (item?.value == "60_to_90_days") {
                  return <td>{currencySignAndNegativeValueAdjust(currencySign ,itemData["60_to_90_days"]?.toFixed(2))}</td>;
                } else if (item?.value == "more_than_90_days") {
                  return <td>{currencySignAndNegativeValueAdjust(currencySign ,itemData["more_than_90_days"]?.toFixed(2))}</td>;
                } 
                else if (item?.value == "total_amount") {
                  return <td>{currencySignAndNegativeValueAdjust(currencySign ,itemData["total_amount"]?.toFixed(2))}</td>;
                }
                else {
                  <td>{itemData[item?.value]}</td>;
                }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default AgeingAnalysisTableData;
